/**
 * Module: Hero Swiper Slider
 * Description: Inizializza lo slider Swiper per la Hero della Homepage.
 */

export function initHeroSlider() {
	
	if (typeof Swiper === "undefined") {
		console.warn("Swiper non disponibile per lo slider Hero!");
		return;
	}

	const sliders = document.querySelectorAll(".swiper-hero-slider");

	if (sliders.length === 0) {
		return;
	}

	sliders.forEach((slider, index) => {

		// Parametri dai data-attributes con fallback
		const autoplayDelay = parseInt(slider.dataset.swiperAutoplay) || 5000;
		const speed = parseInt(slider.dataset.swiperSpeed) || 1000;
		const loop = slider.dataset.swiperLoop === 'true';
		const slidesCount = slider.querySelectorAll(".swiper-slide").length;

		const wrapperId =
			slider.closest(".swiper-wrapper")?.id || `swiper-hero-slider-${index}`;

		// Debug info in tabella
		console.log(`Inizializzazione Slider Hero [${index + 1}] 👍`);
		console.table({
			"ID": wrapperId,
			"Autoplay": `${autoplayDelay}ms`,
			"Velocità": `${speed}ms`,
			"Loop": loop,
			"Numero Slide": slidesCount
		});

		new Swiper(slider, {
			spaceBetween: 0,
			loop: loop,
			speed: speed,
			autoplay: {
				delay: autoplayDelay,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: ".swiper-pagination-hero-slider",
				clickable: true,
			},
		});
	});
}
